module.exports = __webpack_public_path__ + "img/9-19.73110c8a.jpg";